var map = {
	"./assignatures.castellarnau": 9040,
	"./assignatures.castellarnau.json": 9040,
	"./assignatures.cavallbernat": 4788,
	"./assignatures.cavallbernat.json": 4788,
	"./assignatures.joanoro": 9926,
	"./assignatures.joanoro.json": 9926,
	"./dadesbancaries.castellarnau": 9602,
	"./dadesbancaries.castellarnau.json": 9602,
	"./dadesbancaries.cavallbernat": 9548,
	"./dadesbancaries.cavallbernat.json": 9548,
	"./dadesbancaries.joanoro": 6529,
	"./dadesbancaries.joanoro.json": 6529,
	"./families.castellarnau": 7439,
	"./families.castellarnau.json": 7439,
	"./families.cavallbernat": 899,
	"./families.cavallbernat.json": 899,
	"./families.joanoro": 2824,
	"./families.joanoro.json": 2824,
	"./llista_bonificacions": 4042,
	"./llista_bonificacions.json": 4042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6482;